import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Modal } from "react-bootstrap";
import doorsArray from "./inventory/doorsArray";
import windowsArray from "./inventory/windowsArray";
import garageDoorsArray from "./inventory/garageDoorsArray";
import accessoriesArray from "./inventory/accessoriesArray";
import { useTranslation } from "react-i18next";
import { storage, getDownloadURL, ref } from "../../base";
import DoorsSelectionViewModal from "../doorsSelectionView/DoorsSelectionViewModal";
import "./ItemSelectionViewModal.css";

function ItemSelectionViewModal(props) {
  const { t } = useTranslation(["translation"]);
  const [showDoorsModal, setShowDoorsModal] = useState(false);
  const [selectedDoorType, setSelectedDoorType] = useState("");
  const [selectedDoorURL, setSelectedDoorURL] = useState("");
  const [selectedAccessoryType, setSelectedAccessoryType] = useState("");

  const getStoragePath = (url) => url.replace(/^\//, "");
  const getPublicImagePath = (url) => `${process.env.PUBLIC_URL}${url.startsWith("/") ? url : `/${url}`}`;
  const isAccessoriesMode = props.itemToSearch === "Accessories";

  if (!props.show && !showDoorsModal) {
    return null;
  }

  function arrayChoice() {
    switch (props.itemToSearch) {
      case "Single Door":
      case "Single Door Right SideLight":
      case "Single Door Right SideLight Full":
      case "Single Door Left SideLight":
      case "Single Door Left SideLight Full":
      case "Single Door Right Left SideLight":
      case "Single Door Right Left SideLight Full":
      case "Double Door":
      case "Double Door Right Left SideLight":
      case "Double Door Right Left SideLight Full":
        return doorsArray;

      case "Casement":
      case "Sash":
      case "Slider":
      case "Contemporary":
      case "Fixe":
        return windowsArray;

      case "Garage Door":
        return garageDoorsArray;

      default:
        return windowsArray;
    }
  }

  function onClickEvent(item, tName) {
    const storageRef = storage.ref();
    const imageRef = ref(storageRef, getStoragePath(item.url));
    
    getDownloadURL(imageRef).then((highQualityURL) => {
      document.body.style.overflow = "auto";

      // For windows - add directly and close all modals
      if (!tName.replaceAll("_", " ").includes("Door")) {
        props.addItem(highQualityURL, tName, null, false);
        document.body.style.overflow = "auto";
        if (props.onFinalClose) {
          props.onFinalClose(); // Close all parent modals
        } else {
          props.onHide();
        }
      } 
      // For garage doors - add directly and close all modals
      else if (tName.replaceAll("_", " ").includes("Garage Door")) {
        props.addItem(highQualityURL, tName, null, false);
        if (props.onFinalClose) {
          props.onFinalClose(); // Close all parent modals
        } else {
          props.onHide();
        }
      } 
      // For regular doors - open the third level modal with all door configurations
      else {
        setSelectedDoorType(tName);
        setSelectedDoorURL(highQualityURL);
        setShowDoorsModal(true);
      }
    });
  }
  
  const handleDoorsModalHide = () => {
    setShowDoorsModal(false);
  };
  
  const handleDoorsModalFinalClose = () => {
    setShowDoorsModal(false);
    // Close all parent modals
    if (props.onFinalClose) {
      props.onFinalClose();
    } else {
      props.onHide();
    }
  };

  const portalContainer = document.body;

  if (!portalContainer) {
    return null;
  }

  const filteredItems = arrayChoice().filter((item) => {
    const imgName = item.name.replaceAll("_", " ");
    return (
      imgName.includes(props.itemToSearch) &&
      !item.url.includes("Full") &&
      !item.url.includes("SidelightB")
    );
  });

  const accessoryTypes = [
    {
      id: "Transoms",
      label: t("accessories-transoms", "Transoms"),
      thumbnail: "/thumbnails/Window_Fixed_HalfMoon.png",
      disabled: true,
    },
    {
      id: "Shutters",
      label: t("accessories-shutters", "Shutters"),
      thumbnail: "/shutters/shutter_standard_white.png",
      disabled: false,
    },
    {
      id: "Decorative",
      label: t("accessories-trims", "Decorative"),
      thumbnail: "/decorative/doorKnocker1_silver.png",
      disabled: false,
    },
  ];

  const filteredAccessories = accessoriesArray.filter(
    (accessory) => accessory.type === selectedAccessoryType
  );

  const handleAccessoryTypeClick = (accessoryType) => {
    if (accessoryType === "Transoms") {
      return;
    }

    setSelectedAccessoryType(accessoryType);
  };

  const handleAccessoryClick = (accessory) => {
    if (typeof props.onAccessorySelect === "function") {
      props.onAccessorySelect(accessory);
    }

    if (props.onFinalClose) {
      props.onFinalClose();
    } else {
      props.onHide();
    }
  };

  const handleBack = () => {
    if (isAccessoriesMode && selectedAccessoryType) {
      setSelectedAccessoryType("");
      return;
    }

    props.onHide();
  };

  const modalContent = (
    <Modal
      show={props.show}
      onHide={handleBack}
      size="xl"
      className="item-selection-view-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {isAccessoriesMode
            ? selectedAccessoryType
              ? t("accessories-availableAccessories", "Selection")
              : t("itemSelection-accessories", "Accessories")
            : t("itemSelection-configurations", "Configurations")}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isAccessoriesMode ? (
          <div className="item-selection-grid">
            {selectedAccessoryType
              ? filteredAccessories.map((accessory) => (
                  <div
                    key={accessory.key}
                    className="item-selection-card"
                    onClick={() => handleAccessoryClick(accessory)}
                    title={t(accessory.name)}
                  >
                    <div className="item-selection-thumbnail">
                      <img src={getPublicImagePath(accessory.url)} alt={t(accessory.name)} />
                    </div>
                    <div className="item-selection-name">{t(accessory.name)}</div>
                  </div>
                ))
              : accessoryTypes.map((accessoryType) => (
                  <div
                    key={accessoryType.id}
                    className={`item-selection-card${accessoryType.disabled ? " disabled" : ""}`}
                    onClick={() => handleAccessoryTypeClick(accessoryType.id)}
                    title={accessoryType.label}
                  >
                    <div className="item-selection-thumbnail">
                      <img src={getPublicImagePath(accessoryType.thumbnail)} alt={accessoryType.label} />
                    </div>
                    <div className="item-selection-name">{accessoryType.label}</div>
                  </div>
                ))}
          </div>
        ) : (
          <div className="item-selection-grid">
            {filteredItems.length === 0 ? (
              <div className="no-items-message">
                <p>{t("itemSelection-noItemsAvailable", "No items available")}</p>
              </div>
            ) : (
              filteredItems.map((item) => {
                const imgName = item.name.replaceAll("_", " ");
                const localImagePath = getPublicImagePath(item.url);

                return (
                  <div
                    key={item.key}
                    className="item-selection-card"
                    onClick={() => onClickEvent(item, item.name)}
                    title={imgName}
                  >
                    <div className="item-selection-thumbnail">
                      <img src={localImagePath} alt={imgName} />
                    </div>
                    <div className="item-selection-name">{imgName}</div>
                  </div>
                );
              })
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );

  // Use React Portal to render modal in canvasContainer
  return (
    <>
      {ReactDOM.createPortal(modalContent, portalContainer)}
      {showDoorsModal && (
        <DoorsSelectionViewModal
          show={showDoorsModal}
          onHide={handleDoorsModalHide}
          onFinalClose={handleDoorsModalFinalClose}
          typeName={selectedDoorType}
          addItem={props.addItem}
        />
      )}
    </>
  );
}

export default ItemSelectionViewModal;
